jQuery(document).ready(function ($) {

  // ==========================================================================
  // Header Show/Hide on Scroll
  // ==========================================================================
  const $header = $('.page-header');
  let lastScrollY = $(window).scrollTop();
  let hideTimeout;

  function handleScroll() {
    const currentY = Math.round($(window).scrollTop());

    if (currentY <= 0) {
      $header.removeClass('header--hidden');
      clearTimeout(hideTimeout);
    } else if (currentY > lastScrollY) {
      $header.addClass('header--hidden');
      clearTimeout(hideTimeout);
    } else {
      $header.removeClass('header--hidden');
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        $header.addClass('header--hidden');
      }, 1500);
    }

    lastScrollY = currentY;
  }

  $(window).on('scroll', handleScroll);
  $header.on('mouseenter', () => clearTimeout(hideTimeout));

  // ==========================================================================
  // Submenu Arrows (Desktop & Mobile)
  // ==========================================================================
  document.querySelectorAll('.primary-navigation .menu-item-has-children, #primary-menu-mobile .menu-item-has-children')
    .forEach(item => {
      const link = item.querySelector('a');
      const href = link?.getAttribute('href');
      const isInactiveLink = !href || href === '#' || href.trim() === '';

      if (!item.querySelector('.submenu-toggle')) {
        const button = document.createElement('button');
        button.className = 'submenu-toggle';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Untermenü öffnen');
        button.innerHTML = `
          <svg class="icon icon-arrow" viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="6 9 12 15 18 9" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;
        item.appendChild(button);

        button.addEventListener('click', e => {
          e.preventDefault();
          toggleSubmenu(item, button);
        });
      }

      if (isInactiveLink) {
        link?.addEventListener('click', e => {
          e.preventDefault();
          const button = item.querySelector('.submenu-toggle');
          toggleSubmenu(item, button);
        });
      }
    });

  function toggleSubmenu(parent, button) {
    const submenu = parent.querySelector('.sub-menu');

    document.querySelectorAll('.menu-item-has-children').forEach(i => {
      if (i !== parent) {
        i.classList.remove('is-open');
        i.querySelector('.submenu-toggle')?.setAttribute('aria-expanded', 'false');
        i.querySelector('.sub-menu')?.classList.remove('sub-menu-open');
      }
    });

    const isOpen = parent.classList.toggle('is-open');
    button?.setAttribute('aria-expanded', isOpen);
    if (submenu) submenu.classList.toggle('sub-menu-open', isOpen);
  }

  // ==========================================================================
  // Mobile Menu Toggle & Body Scroll Lock
  // ==========================================================================
  const $root = $('html, body');
  const $nav = $('.page-header__mobile');

  $(document).on('click', '.hamburger-container', function (e) {
    e.preventDefault();
    $root.toggleClass('no-scroll');
    $nav.toggleClass('active');
  });

  $nav.on('click', 'a', function (e) {
    const href = $(this).attr('href');
    if (!href || href === '#' || href.trim() === '') {
      e.preventDefault(); 
      return;
    }
    $root.removeClass('no-scroll');
    $nav.removeClass('active');
  });

  // ==========================================================================
  // Anker-Scroll (mit Offset + Menüschließen)
  // ==========================================================================
  function scrollToElement(element) {
    const offset = $(window).width() > 1168 ? 160 : 100;
    $('html, body').animate({
      scrollTop: $(element).offset().top - offset
    }, 400);
  }

  function closeMobileMenu(callback) {
    if ($nav.hasClass('active')) {
      $root.removeClass('no-scroll');
      $nav.removeClass('active');
      setTimeout(() => {
        if (typeof callback === 'function') callback();
      }, 400);
    } else {
      if (typeof callback === 'function') callback();
    }
  }

  $('a[href*="#"]').on('click', function (e) {
    const target = $(this.hash);
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
      location.hostname === this.hostname &&
      target.length
    ) {
      e.preventDefault();
      closeMobileMenu(() => {
        scrollToElement(target);
      });
    }
  });

  if (window.location.hash) {
    const target = $(window.location.hash);
    if (target.length) {
      $(window).on('load', () => {
        closeMobileMenu(() => {
          scrollToElement(target);
        });
      });
    }
  }

  $(window).on('hashchange', () => {
    const target = $(window.location.hash);
    if (target.length) {
      scrollToElement(target);
    }
  });

  // ==========================================================================
  // Content-Menu Toggle
  // ==========================================================================
  $('.content__menu').on('click', function () {
    $(this).toggleClass('menu-open');
  });

  // ==========================================================================
  // Dynamische CSS-Variable: --vh (Viewport Height minus Header)
  // ==========================================================================
  function updateVh() {
    const headerH = $header.outerHeight() || 0;
    const vh = (window.innerHeight - headerH) * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  updateVh();
  $(window).on('resize orientationchange', () => {
    setTimeout(updateVh, 100);
  });

  // ==========================================================================
  // Visited-State im Header
  // ==========================================================================
  const currentUrl = window.location.href.split(/[?#]/)[0];
  $('.page-header a').each(function () {
    if ($(this).prop('href') === currentUrl) {
      $(this).addClass('is-visited')
        .closest('.menu-item-has-children')
        .children('a')
        .addClass('is-visited');
    }
  });

}); // End of document.ready



// ==========================================================================
// Add Controls to Video on Hover
// ==========================================================================

jQuery(document).ready(function($) {
    $('.block-video__wrapper').each(function () {
        const $wrapper = $(this);
        const videoEl = $wrapper.find('video').get(0);
        const $playBtn = $wrapper.find('.block-video__play-button');

        // Versuche Autoplay
        const playPromise = videoEl.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                $playBtn.css('display', 'none');
            }).catch(() => {
                $playBtn.css('display', 'block');
            });
        }

        // Manuell starten
        $playBtn.on('click', function(e) {
            e.stopPropagation();
            videoEl.play();
            $playBtn.css('display', 'none');
        });
    });
});

// ==========================================================================
// Block Accordion: Add ARIA and Toggle Functionality
// ==========================================================================

jQuery(function ($) {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D = reduce ? 0 : 260; // Dauer

  $('.js-accordion[data-module="accordion"]').each(function () {
    var $root   = $(this);
    var $list   = $root.find('.accordion__list');
    var $items  = $list.find('.accordion__item');
    var $btns   = $items.find('.accordion__item--header');
    var $panels = $items.find('.accordion__item--panel');

    // Init: alles zu
    $btns.attr('aria-expanded', 'false');
    $panels.attr('hidden', true).stop(true, true).hide();

    function open($btn, $panel) {
      // andere schließen
      $btns.not($btn).attr('aria-expanded', 'false');
      $items.not($btn.closest('.accordion__item')).removeClass('is-open');
      $panels.not($panel).stop(true, true).slideUp(D, function () {
        $(this).attr('hidden', true);
      });

      // aktuelles öffnen
      $btn.attr('aria-expanded', 'true').closest('.accordion__item').addClass('is-open');
      $panel.attr('hidden', false).stop(true, true).slideDown(D, function () {
        // cleanup
        $(this).css('height', '');
      });
    }

    function close($btn, $panel) {
      $btn.attr('aria-expanded', 'false').closest('.accordion__item').removeClass('is-open');
      $panel.stop(true, true).slideUp(D, function () {
        $(this).attr('hidden', true);
      });
    }

    // Click: Header-Button
    $btns.on('click', function () {
      var $btn   = $(this);
      var panelId = $btn.attr('aria-controls');
      var $panel  = $('#' + panelId);
      var isOpen  = $btn.attr('aria-expanded') === 'true';
      if (isOpen) { close($btn, $panel); } else { open($btn, $panel); }
    });

    // Tastatur: ↑ ↓ Home End
    $list.on('keydown', function (e) {
      var keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (keys.indexOf(e.key) === -1) return;
      var i = $btns.index($(document.activeElement));
      if (i === -1) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') $btns.eq((i + 1) % $btns.length).focus();
      else if (e.key === 'ArrowUp') $btns.eq((i - 1 + $btns.length) % $btns.length).focus();
      else if (e.key === 'Home') $btns.eq(0).focus();
      else if (e.key === 'End')  $btns.eq($btns.length - 1).focus();
    });

    // Optional: per Hash (#buttonId oder #panelId) öffnen
    var hash = window.location.hash.slice(1);
    if (hash) {
      var $btnH = $btns.filter('#' + hash);
      var $panH = $panels.filter('#' + hash);
      var $btnTarget, $panTarget;
      if ($btnH.length) { $btnTarget = $btnH; $panTarget = $('#' + $btnH.attr('aria-controls')); }
      else if ($panH.length) { $panTarget = $panH; $btnTarget = $('#' + $panH.attr('aria-labelledby')); }
      if ($btnTarget && $panTarget) open($btnTarget, $panTarget);
    }
  });
});













